import Vue from 'vue';
import Projects from '../vue/projects.vue';
class projects {
	constructor() {
		
	}
	show(el) {
		this.projectsApp = new Vue(Projects).$mount(el.querySelector('.row'));
	}
}

window.app.add('projects', new projects());